import { render, staticRenderFns } from "./ListStockDebt.vue?vue&type=template&id=bdc76500&scoped=true&"
import script from "./ListStockDebt.vue?vue&type=script&lang=js&"
export * from "./ListStockDebt.vue?vue&type=script&lang=js&"
import style0 from "./ListStockDebt.vue?vue&type=style&index=0&id=bdc76500&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc76500",
  null
  
)

export default component.exports